const togglerFormations = $('#offcanvas-toggler-formations');
const togglerExpertises = $('#offcanvas-toggler-expertises');
const togglerJob = $('#offcanvas-toggler-job');

const offcanvasFormations = $('#offcanvas-menu-formations');
const offcanvasExpertises = $('#offcanvas-menu-expertises');
const offcanvasJob = $('#offcanvas-menu-job');

togglerFormations.on('click', () => {
	togglerFormations.toggleClass('active');
});

togglerExpertises.on('click', () => {
	togglerExpertises.toggleClass('active');
});

togglerJob.on('click', () => {
	togglerJob.toggleClass('active');
});

offcanvasFormations.on('hidden.bs.offcanvas', () => {
  togglerFormations.removeClass('active');
});

offcanvasExpertises.on('hidden.bs.offcanvas', () => {
  togglerExpertises.removeClass('active');
});

offcanvasJob.on('hidden.bs.offcanvas', () => {
  togglerJob.removeClass('active');
});

